import { useState, type FormEvent } from 'react';

type AdminLoginProps = {
  onSubmit: (credentials: { email: string; password: string }) => Promise<void>;
  isSubmitting: boolean;
  errorMessage: string;
};

export default function AdminLogin({ onSubmit, isSubmitting, errorMessage }: AdminLoginProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await onSubmit({ email, password });
  };

  return (
    <div className="mx-auto max-w-xl rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm">
      <h2 className="text-3xl font-black text-slate-900">Admin Login</h2>
      <p className="mt-3 text-sm leading-7 text-slate-600">
        Sign in with the customer CMS account you created in Supabase Auth.
      </p>
      <form onSubmit={handleSubmit} className="mt-8 space-y-5">
        <label className="block text-sm font-semibold text-slate-700">
          <span className="mb-2 block">Email</span>
          <input
            type="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="w-full rounded-2xl border border-slate-300 px-4 py-3 outline-none transition focus:border-[#33b300]"
          />
        </label>
        <label className="block text-sm font-semibold text-slate-700">
          <span className="mb-2 block">Password</span>
          <input
            type="password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className="w-full rounded-2xl border border-slate-300 px-4 py-3 outline-none transition focus:border-[#33b300]"
          />
        </label>
        {errorMessage ? <p className="text-sm font-semibold text-red-600">{errorMessage}</p> : null}
        <button
          type="submit"
          disabled={isSubmitting}
          className="inline-flex items-center justify-center rounded-full bg-[#0d4f12] px-6 py-3 font-bold text-white transition hover:bg-[#0a3c0e] disabled:cursor-not-allowed disabled:opacity-60"
        >
          {isSubmitting ? 'Signing in...' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}
